module.exports = __webpack_public_path__ + "static/img/industry-case-banner.d43f9a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industry-case-banner.jpg
// module id = e3R4
// module chunks = 1